// assets
import {
  AntDesignOutlined,
  AppstoreOutlined,
  BarcodeOutlined,
  BgColorsOutlined,
  FontSizeOutlined,
  LoadingOutlined,
  ShoppingCartOutlined,
  HeartOutlined,
  ProductOutlined,
  MessageOutlined,
  TagsOutlined,
  RocketOutlined,
  MailOutlined,
  FileTextOutlined
  
} from '@ant-design/icons';


// icons
const icons = {
  FontSizeOutlined,
  BgColorsOutlined,
  BarcodeOutlined,
  AppstoreOutlined,
  AntDesignOutlined,
  LoadingOutlined,
  ShoppingCartOutlined,
  HeartOutlined,
  ProductOutlined,
  MessageOutlined,
  TagsOutlined,
  RocketOutlined,
  MailOutlined,
  FileTextOutlined

  
};


 


// ==============================|| MENU ITEMS - UTILITIES ||============================== //

const utilities = {
  id: 'utilities',
  title: 'Product Details',
  type: 'group',
  children: [
    {
      id: 'mainprice',
      title: 'Main Price',
      type: 'item',
      url: '/MainPriceForm',
      icon: icons.FontSizeOutlined
    },
    {
      id: 'productlist',
      title: 'Products',
      type: 'item',
      url: '/productlist',
      activeUrls: ['/productlist', '/AddProduct'],
      icon: icons.ProductOutlined
    },
    {
      id: 'reviews',
      title: 'Reviews',
      type: 'item',
      url: '/reviews',
      activeUrls: ['/reviews'],
      icon: icons.MessageOutlined
    },
    {
      id: 'custom-product',
      title: 'Custom Product',
      type: 'item',
      url: '/custom-product',
      activeUrls: ['/custom-product'],
      icon: icons.AppstoreOutlined
    },
        {
      id: 'util-color',
      title: 'Categories',
      type: 'item',
      url: '/AddCategory',
      icon: icons.BgColorsOutlined
    },
        {
      id: 'tags',
      title: 'Tags',
      type: 'item',
      url: '/tags',
      icon: icons.TagsOutlined
    },
        {
      id: 'salelist',
      title: 'Sales',
      type: 'item',
      url: '/sales',
      activeUrls: ['/sales', '/sales/new', '/sales/:id/edit'],
      icon: icons.RocketOutlined
    },

    {
      id: 'couponlist',
      title: 'Coupons',
      type: 'item',
      url: '/coupons',
      activeUrls: ['/coupons', '/coupons/new', '/coupons/:id/edit'],
      icon: icons.BarcodeOutlined
    },
    {
      id: 'newsletter',
      title: 'Newsletter',
      type: 'item',
      url: '/newsletter',
      activeUrls: ['/newsletter'],
      icon: icons.MailOutlined
    },
    {
      id: 'blogs',
      title: 'Blogs',
      type: 'item',
      url: '/blogs',
      activeUrls: ['/blogs', '/blogs/new', '/blogs/:id/edit'],
      icon: icons.FileTextOutlined
    },
    
    {
      id: 'Media',
      title: 'Media Upload',
      type: 'item',
      url: '/MediaLibrary',
      icon: icons.BarcodeOutlined
    }




    

    

    
    
  ]
};

export default utilities;
